import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { HorsesEffects } from './effects/horses.effects';
import * as fromHorses from './reducers/horses.reducer';
import { HorseService } from './services/horse.service';
import { HorseStoreFacade } from './facades/horse-store.facade';
import { AuthService } from '../auth-store';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromHorses.horsesFeatureKey, fromHorses.reducer),
    EffectsModule.forFeature([HorsesEffects]),
  ],
  providers: [HorseService, HorseStoreFacade, AuthService],
})
export class HorsesStoreModule {}
